import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'

import PropTypes from 'prop-types'

import './footer4.css'

const Footer4 = (props) => {
  return (
    <footer className="footer4-footer7 thq-section-padding">
      <div className="footer4-max-width thq-section-max-width">
        <div className="footer4-content">
          <div className="footer4-logo1">
            <img
              alt={props.logoAlt}
              src={props.logoSrc}
              className="footer4-logo2"
            />
          </div>
          <div className="footer4-links">
            <Link to="/" className="footer4-navlink1 thq-body-small">
              {props.link1 ?? (
                <Fragment>
                  <span className="footer4-text7">About Us</span>
                </Fragment>
              )}
            </Link>
            <Link to="/" className="footer4-navlink2 thq-body-small">
              {props.link2 ?? (
                <Fragment>
                  <span className="footer4-text6">Our Team</span>
                </Fragment>
              )}
            </Link>
            <a
              href="mailto:admin@signbridge.com?subject=Connect to our team"
              className="footer4-link1 thq-body-small"
            >
              {props.link3 ?? (
                <Fragment>
                  <span className="footer4-text5">Contact Us</span>
                </Fragment>
              )}
            </a>
            <a
              href="mailto:admin@signbridge.com?subject=Connect to us"
              className="footer4-link2 thq-body-small"
            >
              {props.link4 ?? (
                <Fragment>
                  <span className="footer4-text9">Partnerships</span>
                </Fragment>
              )}
            </a>
          </div>
        </div>
        <div className="footer4-credits">
          <div className="thq-divider-horizontal"></div>
          <div className="footer4-row">
            <div className="footer4-container">
              <span className="thq-body-small">© 2024 Signbridge AI</span>
            </div>
            <div className="footer4-footer-links">
              <span className="footer4-text2 thq-body-small">
                {props.privacyLink ?? (
                  <Fragment>
                    <span className="footer4-text4">Privacy Policy</span>
                  </Fragment>
                )}
              </span>
              <span className="thq-body-small">
                {props.termsLink ?? (
                  <Fragment>
                    <span className="footer4-text8">Terms of Service</span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

Footer4.defaultProps = {
  logoSrc: 'https://presentation-website-assets.teleporthq.io/logos/logo.png',
  privacyLink: undefined,
  link3: undefined,
  link2: undefined,
  logoAlt: 'Signbridge AI Logo',
  link1: undefined,
  termsLink: undefined,
  link4: undefined,
}

Footer4.propTypes = {
  logoSrc: PropTypes.string,
  privacyLink: PropTypes.element,
  link3: PropTypes.element,
  link2: PropTypes.element,
  logoAlt: PropTypes.string,
  link1: PropTypes.element,
  termsLink: PropTypes.element,
  link4: PropTypes.element,
}

export default Footer4
